
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/summer-foundation-course-for-upsc",
      function () {
        return require("private-next-pages/summer-foundation-course-for-upsc/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/summer-foundation-course-for-upsc"])
      });
    }
  